module.exports = __webpack_public_path__ + "img/nextspin.377765fb.png";